import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
import { I18nContextProvider } from "./i18n";

import "./scss/styles/app.scss";

ReactDOM.render(
    <I18nContextProvider>
      <App />
    </I18nContextProvider>,
    document.getElementById("root"),
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
